"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _serviceHelpers = require("./serviceHelpers");
var fetchWithAuth = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var endpointUrl, _ref$method, method, route, body, _ref$additionalHeader, additionalHeaders, _ref$giveSimpleRespon, giveSimpleResponse, accessToken, options, fullUrl, rawResponse;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          endpointUrl = _ref.endpointUrl, _ref$method = _ref.method, method = _ref$method === void 0 ? 'GET' : _ref$method, route = _ref.route, body = _ref.body, _ref$additionalHeader = _ref.additionalHeaders, additionalHeaders = _ref$additionalHeader === void 0 ? {} : _ref$additionalHeader, _ref$giveSimpleRespon = _ref.giveSimpleResponse, giveSimpleResponse = _ref$giveSimpleRespon === void 0 ? true : _ref$giveSimpleRespon, accessToken = _ref.accessToken;
          options = (0, _serviceHelpers.buildOptions)(method, body, additionalHeaders, accessToken);
          fullUrl = route ? "".concat(endpointUrl, "/").concat(route) : endpointUrl;
          _context.next = 5;
          return fetch(fullUrl, options);
        case 5:
          rawResponse = _context.sent;
          return _context.abrupt("return", (0, _serviceHelpers.checkResponse)(rawResponse, "".concat(method, " ").concat(fullUrl), giveSimpleResponse));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchWithAuth(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var _default = exports["default"] = fetchWithAuth;